import { requestConfig } from "../config.js";

/**
 * Получить перечень всех населенных пунктов
 */
export async function apiFetchCityList() {
  const response = await requestConfig.get("/api/v0/get_city_list/");

  if (!response?.data) throw new Error("Unable to fetch cities.");

  return response.data.detail;
}
